import { View, Platform } from "react-native";
import React, { useRef, useState } from "react";
import { InputProps, Text } from "@ui-kitten/components";
import Input from "components/Input";
import { useAppDispatch } from "hooks/useAppDispatch";
import { login } from "features/slices/authSlice";
import { useAppSelector } from "hooks/useAppSelector";
import Spacer from "components/Spacer";
import { MaterialIcons } from "@expo/vector-icons";
import Button from "components/Button";
import i18n from "plugins/localization";

interface Props {
  title?: string;
  onSignupClick?: () => void;
  allowSignup?: boolean;
}

const emailIcon = () => <MaterialIcons name="email" size={24} color="black" />;
const lockIcon = () => <MaterialIcons name="lock" size={24} color="black" />;

const inputProps: InputProps = {
  autoCapitalize: "none",
  autoCorrect: false,
};

const Login = (props: Props) => {
  const { title = "", onSignupClick, allowSignup = true } = props;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const ref_password = useRef<any>(null);

  const { loading } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  const handleLogin = () => {
    dispatch(login({ username, password }));
  };

  const onSubmitEditing = () => {
    ref_password.current && ref_password.current.focus();
  };
  return (
    <View>
      <Text category="h6" style={{ textAlign: "center", marginBottom: 4 }}>
        {title}
      </Text>
      {allowSignup && (
        <Button
          size="small"
          appearance="ghost"
          onPress={onSignupClick}
          style={{ marginLeft: 10 }}
          status="info"
        >
          <Text>Don't have an account? Sign up</Text>
        </Button>
      )}
      <Input
        testID="email-input"
        placeholder={i18n.t("labels.email")}
        accessoryLeft={emailIcon}
        value={username}
        onChangeText={setUsername}
        onSubmitEditing={onSubmitEditing}
        onKeyPress={(e) => {
          if (Platform.OS === "web" && e.nativeEvent.key === "Tab") {
            e.preventDefault();
            onSubmitEditing();
          }
        }}
        underlineColorAndroid="transparent"
        {...inputProps}
      ></Input>

      <View style={{ marginVertical: 10 }}></View>

      <Input
        testID="password-input"
        ref={ref_password}
        placeholder={i18n.t("labels.password")}
        accessoryLeft={lockIcon}
        value={password}
        onChangeText={setPassword}
        secureTextEntry={true}
        underlineColorAndroid="transparent"
        onSubmitEditing={handleLogin}
        {...inputProps}
      ></Input>

      <Spacer />

      <Button
        onPress={handleLogin}
        loading={loading}
        testID="login-button"
        style={{ marginBottom: 15 }}
      >
        {i18n.t("common.loginButton")}
      </Button>
    </View>
  );
};

export default Login;
